import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect, withRouter } from 'react-router-dom';

import { MSG_USERNAME_REQUIRED,MSG_PASSWORD_REQUIRED,MSG_AFFILIATE_REQUIRED,MSG_NETWORK_ERROR,MSG_AUTHENTICATION_INVALID, MSG_LOGIN_ERRORS, MSG_FORGOT_PWD_SUCCESS, MSG_FORGOT_PWD_ERROR, MSG_PWD_RESET_SUCCESS, MSG_MAIL_SEND_ERR_CLIENT_EMAILS_MUTED, MSG_MAIL_SEND_ERR_ALL_CLIENTS_EMAIL_MUTED } from '../../../configs/msgConfigs';
import * as labelConfigs from '../../../configs/labelConfigs';
import * as staticConfigs from '../../../configs/staticConfigs'; 
import { setStorage, getStorage, getUserGroupData } from '../../../utils/browserStorage';
import {formValid} from '../../../utils/validation';

import { LOGIN_USER_SUCCESS } from '../../../actions/'; // ,LOGIN_USER_ERROR,LOGIN_CLIENT_AFFILIATE_LIST_SUCCESS,LOGIN_CLIENT_AFFILIATE_LIST_ERROR
import { FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_ERROR } from '../../../actions/';
import { loginUserAction, loginClientAffiliateListAction, forgotPasswordAction } from '../../../actions/authenticationActions';
import { clearAction } from '../../../actions/commonActions';
import LoginHeader from './loginHeader';
import LoginView from './loginView';
import FooterComponent from '../../commons/layouts/footerComponent';

const EXPIRY_IN_DAYS      = 30; 
const SUPERADMIN_UNAME_PWD= "superAdminUNamePwd"; 
const SUPERADMIN_USERNAME = "superAdminUserName";
const SUPERADMIN_PASSWORD = "superAdminPassword";
const AFFILIATE_UNAME_PWD = "affiliateUNamePwd"; 
const AFFILIATE_USERNAME  = "affiliateUserName";
const AFFILIATE_PASSWORD  = "affiliatePassword";
const CLIENT_UNAME_PWD    = "clientUNamePwd";
const CLIENT_USERNAME     = "clientUserName";
const CLIENT_PASSWORD     = "clientPassword"; 
const SEPARATOR           = '~##~'; 

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
  
function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}
  
//   function checkCookie() {
//     let user = getCookie("username");
//     if (user != "") {
//       console.log("Welcome again " + user);
//     } else {
//       user = prompt("Please enter your name:", "");
//       if (user != "" && user != null) {
//         setCookie("username", user, 365);
//       }
//     }
//   }

class LoginComponent extends Component {

    static propTypes = {
        location: PropTypes.object.isRequired,
    };

    constructor(props){
        super();

        this.state = { 
            formErrors:{
              txtUsername: "",
              txtPassword: "",
              sel_affiliate: ""        
            },
            userData:{
              txtUsername: null,
              txtPassword:null,
              sel_affiliate: 0,
            },
            userGroup:null,
            errorMessage:'',
            isLoggedIn: false,
            arrAffiliates: [], 
            forgot_username: '', 
            forgot_username_error: '',
            forgot_password_resp_success: '', 
            forgot_password_resp_error: '', 
            forgotPwdActivity: '',
            loginSubmitted: 0,
            callAcceptTerms: 0, 
            acceptTermsCalled: 0,
            rememberMe: false, 
        }

        this.onHandleLogin = this.onHandleLogin.bind(this);
    } 

    componentDidMount() {
        document.title = labelConfigs.LBL_APP_NAME+' : Login';
        document.body.classList.add('login'); 

        if(this.props.location.pathname.indexOf(staticConfigs.LOGIN_ROUTE_SUPER_ADMIN) >=0) {
            let loginUserName = getCookie(SUPERADMIN_USERNAME); 
            let loginPassword = getCookie(SUPERADMIN_PASSWORD); 
            if (loginUserName != "") {
                let userData = {
                    txtUsername: loginUserName,
                    txtPassword: loginPassword,
                    sel_affiliate: 0,
                }
                this.setState({userData,rememberMe:true}); 
            }  
        } else if(this.props.location.pathname.indexOf(staticConfigs.LOGIN_ROUTE_AFFILIATE) >=0) {
            document.body.classList.add('loginAffiliate');  // TO CHANGE THE linear-gradient color
            let loginUserName = getCookie(AFFILIATE_USERNAME); 
            let loginPassword = getCookie(AFFILIATE_PASSWORD); 
            if (loginUserName != "") {
                let userData = {
                    txtUsername: loginUserName,
                    txtPassword: loginPassword,
                    sel_affiliate: 0,
                }
                this.setState({userData,rememberMe:true}); 
            }  
        } 
        else if(this.props.location.pathname.indexOf(staticConfigs.LOGIN_ROUTE_CLIENT) >=0) {
            document.body.classList.add('loginClient');  // TO CHANGE THE linear-gradient color
            let loginUserName = getCookie(CLIENT_USERNAME);
            let loginPassword = getCookie(CLIENT_PASSWORD); 
            if (loginUserName != "") {
                let userData = {
                    txtUsername: loginUserName,
                    txtPassword: loginPassword,
                    sel_affiliate: 0,
                }
                this.setState({userData,rememberMe:true}); 
            }  
        }

        this.setState({callAcceptTerms:0,acceptTermsCalled:0});
        if(getStorage('termsUserData')!==null && getStorage('termsUserData')) {
            let termsUserData = JSON.parse(getStorage('termsUserData')); 
            if(termsUserData && termsUserData.txtUsername.length > 0 && termsUserData.txtPassword.length > 0) {
                if(termsUserData.userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP) { }
                let userData = {
                    txtUsername: termsUserData.txtUsername,
                    txtPassword: termsUserData.txtPassword,
                    sel_affiliate: 0,
                }
                this.setState({userData,loginSubmitted:0}, () => {
                    setStorage('termsUserData',JSON.stringify({
                        txtUsername: '',
                        txtPassword: '',
                        sel_affiliate: 0,
                    })); 
                    this.onHandleLogin(''); 
                }); 
            }
        }
    }
    
    componentWillUnmount() {
        document.body.classList.remove('login'); 
        document.body.classList.remove('loginAffiliate'); 
        document.body.classList.remove('loginClient'); 
        document.body.classList.remove('home'); 
        
        if(this.state.userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate');
        }
    }

    onRememberMe = (e) => {
        this.setState({rememberMe:!this.state.rememberMe})
    }

    onHandleChange = (event) =>{
        event.preventDefault();

        const {name,value} = event.target;
        let formErrors     = this.state.formErrors;
        let forgot_username = ''; 
        let forgot_username_error = ''; 
        let forgot_password_resp_error = ''; 
        switch(name){
            case 'txtUsername':
                forgot_username = value;
                formErrors.txtUsername = value.length <=0 ? MSG_USERNAME_REQUIRED : "";
                break;
            case 'txtPassword':
                formErrors.txtPassword = value.length <=0 ? MSG_PASSWORD_REQUIRED : "";
                break; 
            case 'sel_affiliate':
                formErrors.sel_affiliate = Number(value) <=0 ? MSG_AFFILIATE_REQUIRED : ""
                break;   
            case 'forgot_username' : 
                forgot_username = value; 
                forgot_username_error = value.length <=0 ? MSG_USERNAME_REQUIRED : ""
                break;
            default :
                break;
        }
        
        if(name!=='forgot_username') {
            let userData   = this.state.userData; 
            userData[name] = value;
            this.setState({formErrors,userData, forgot_username, forgot_username_error, errorMessage:'', loginSubmitted:0});
        }
        else {
            this.setState({forgot_username, forgot_username_error, forgot_password_resp_error, errorMessage:'', loginSubmitted:0});
        }
    }

    handleForgotPassword = (e) => {
        e.preventDefault();
        let forgot_username = this.state.forgot_username; 
        if(forgot_username.trim().length==0) {
            this.setState({forgot_username_error:MSG_USERNAME_REQUIRED});
        }
        else {
            let userData= { email:this.state.forgot_username }; 
            this.props.dispatch(forgotPasswordAction(userData));
        }
    }

    handleSelAffiliate = (event) => {
        event.preventDefault();
    }

    onHandleLogin = (event) => {

        if(event) event.preventDefault();
        const { location } = this.props;
        let userGroup = '';

        if (location.pathname === staticConfigs.LOGIN_ROUTE_SUPER_ADMIN){
            userGroup = staticConfigs.LOGIN_SUPER_ADMIN_GROUP;
        }else if(location.pathname === staticConfigs.LOGIN_ROUTE_AFFILIATE){
            userGroup = staticConfigs.LOGIN_AFFILIATE_GROUP;
        }else if(location.pathname === staticConfigs.LOGIN_ROUTE_CLIENT){
            userGroup = staticConfigs.LOGIN_CLIENT_GROUP;
        }

        this.setState({userGroup:userGroup,acceptTermsCalled:0});

        if(formValid(this.state)){
            // handle the case where we don't detect the browser
            let userData = {
                username: this.state.userData.txtUsername,
                password: this.state.userData.txtPassword,
                group:userGroup,
            }
            const { detect } = require('detect-browser');
            const browser = detect();
            if (browser) {
                userData['browser'] = browser.name + ': ' + browser.version
                userData['os'] = browser.os
            }
            const publicIp = require('public-ip');
            (async () => {
                userData['ip_address'] = await publicIp.v4();
                this.props.dispatch(loginUserAction(userData));
                this.setState({loginSubmitted:1});

                if (location.pathname === staticConfigs.LOGIN_ROUTE_SUPER_ADMIN){
                    if(this.state.rememberMe) {
                        setCookie(SUPERADMIN_UNAME_PWD, this.state.userData.txtUsername+SEPARATOR+this.state.userData.txtPassword, EXPIRY_IN_DAYS); 
                    }
                    else {
                        setCookie(SUPERADMIN_UNAME_PWD, '0'+SEPARATOR+'0', EXPIRY_IN_DAYS); 
                    }
                }else if(location.pathname === staticConfigs.LOGIN_ROUTE_AFFILIATE){  
                    if(this.state.rememberMe) {
                        setCookie(AFFILIATE_UNAME_PWD, this.state.userData.txtUsername+SEPARATOR+this.state.userData.txtPassword, EXPIRY_IN_DAYS); 
                    }
                    else {
                        setCookie(AFFILIATE_UNAME_PWD, '0'+SEPARATOR+'0', EXPIRY_IN_DAYS); 
                    }
                }else if(location.pathname === staticConfigs.LOGIN_ROUTE_CLIENT){
                    if(this.state.rememberMe) {
                        setCookie(CLIENT_UNAME_PWD, this.state.userData.txtUsername+SEPARATOR+this.state.userData.txtPassword, EXPIRY_IN_DAYS); 
                    }
                    else {
                        setCookie(CLIENT_UNAME_PWD, '0'+SEPARATOR+'0', EXPIRY_IN_DAYS); 
                    }
                }
            })();
        }else{
            let formErrors = this.state.formErrors;
            if(this.state.userData.txtUsername==null){
                formErrors.txtUsername = MSG_USERNAME_REQUIRED;
            }  
            if(this.state.userData.txtPassword==null){
                formErrors.txtPassword = MSG_PASSWORD_REQUIRED;
            } 

            this.setState({formErrors});

        }

    }

    setAffiliate = () => {
        if(Number(this.state.userData.sel_affiliate)===0) {
            let errData = this.state.formErrors; 
            errData.sel_affiliate = MSG_AFFILIATE_REQUIRED; 
            this.setState({formErrors:errData}); 
            return false; 
        }
        else {
            let storageData = getUserGroupData('client');
            if(storageData!==null){
                let currSymbol = '\u00A3'; 
                let currObject = {}; 
                let arrAffiliates = this.state.arrAffiliates; 
                let afltObject = arrAffiliates.filter(item => Number(item.company_id)===Number(this.state.userData.sel_affiliate)); 
                let distance_unit = staticConfigs.DISTANCE_UNIT; 
                let is_active = true; 
                let supervisor_name = ''; 
                let staff_name = ''; 
                let csv_template_path = ''; 
                if(afltObject.length) {
                    currSymbol = afltObject[0].currency_symbol; 
                    currObject = {"currency_id": afltObject[0].currency_id,
                    "currency_name": afltObject[0].currency_name,
                    "currency_symbol": afltObject[0].currency_symbol}; 
                    distance_unit = afltObject[0].distance_unit && afltObject[0].distance_unit.trim().length > 0 ? afltObject[0].distance_unit : staticConfigs.DISTANCE_UNIT;  
                    is_active = afltObject[0].is_active?afltObject[0].is_active:false; 
                    supervisor_name = afltObject[0].supervisor_name?afltObject[0].supervisor_name:''; 
                    staff_name = afltObject[0].staff_name?afltObject[0].staff_name:''; 
                    csv_template_path = afltObject[0].csv_template_path?afltObject[0].csv_template_path:''; 
                }

                storageData.profile_currency = currSymbol; 
                storageData.profile_currency_object = currObject; 
                storageData.client_default_affiliate_id = this.state.userData.sel_affiliate;
                storageData.distance_unit = distance_unit;  
                storageData.is_active = is_active; 
                storageData.supervisor_name = supervisor_name;
                storageData.staff_name = staff_name;
                storageData.csv_template_path = csv_template_path; 
                setStorage('client', JSON.stringify(storageData));
                this.props.history.push(staticConfigs.ROUTE_CLIENT_DASHBOARD); 
            }
        }
    }  

    static getDerivedStateFromProps(nextProps, prevState, state) { 
        // {"loginActivity":"LOGIN_USER_SUCCESS","response":{"status":400,"statusText":"","message":"terms_and_conditions_not_accepted"}}
        if(nextProps.response.login.loginActivity==LOGIN_USER_SUCCESS && nextProps.response.login.response.status==400 && nextProps.response.login.response.message==staticConfigs.TERMS_NOT_ACCEPTED) {
            return { callAcceptTerms:1 };
        }
        else if (nextProps.response.login.hasOwnProperty('forgotPwdResponse') && nextProps.response.login.forgotPwdResponse) {
            if(nextProps.response.login.forgotPwdActivity!==prevState.forgotPwdActivity){ 
                // FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_ERROR
                let forgotPwdResponse = nextProps.response.login.forgotPwdResponse; 
                if(forgotPwdResponse.status && forgotPwdResponse.status===200 && forgotPwdResponse.data.message && forgotPwdResponse.data.message==='verification_email_send') { 
                    return {
                        forgot_password_resp_success: MSG_PWD_RESET_SUCCESS, 
                        forgot_password_resp_error: '',
                        forgotPwdActivity: nextProps.response.login.forgotPwdActivity
                    };
                }
                else if(forgotPwdResponse.status && forgotPwdResponse.status===200 && forgotPwdResponse.data.message && forgotPwdResponse.data.message==='forgot_password_email_send') {
                    return {
                        forgot_password_resp_success: MSG_FORGOT_PWD_SUCCESS, 
                        forgot_password_resp_error: '',
                        forgotPwdActivity: nextProps.response.login.forgotPwdActivity
                    }; 
                }
                else {
                    let forgotPwdErrMsg = MSG_FORGOT_PWD_ERROR; 
                    if (forgotPwdResponse?.message) { 
                        forgotPwdErrMsg = forgotPwdResponse.message===staticConfigs.CLIENT_EMAILS_MUTED ? MSG_MAIL_SEND_ERR_CLIENT_EMAILS_MUTED : 
                        forgotPwdResponse.message===staticConfigs.AFFILIATE_ALL_CLIENTS_EMAILS_MUTED ? MSG_MAIL_SEND_ERR_ALL_CLIENTS_EMAIL_MUTED : 
                        MSG_FORGOT_PWD_ERROR;
                    } 
                    return {
                        forgot_password_resp_success: '', 
                        forgot_password_resp_error: forgotPwdErrMsg,
                        forgotPwdActivity: nextProps.response.login.forgotPwdActivity
                    };
                }
            }
        }

        if (nextProps.response.login.hasOwnProperty('response') && nextProps.response.login.response) {

            if(nextProps.response.login.response.hasOwnProperty('data') && nextProps.response.login.response.data.hasOwnProperty('affiliates')) {
                let arrAflt = []; 
                if(Array.isArray(nextProps.response.login.response.data.affiliates)) arrAflt = nextProps.response.login.response.data.affiliates; 
                return { arrAffiliates: arrAflt}; 
            }
            else if ((!nextProps.response.login.response.hasOwnProperty('affiliates')) && (nextProps.response.login.response) && nextProps.response.login.response.status===200) {
                let loginResponse = nextProps.response.login.response.data;
                
                // loginResponse.affiliates

                let colors = staticConfigs.RANDOM_COLORS;
                let rand = Math.floor(Math.random()*colors.length);
                let currSymbol = (loginResponse.data.currency.currency_symbol) ? (loginResponse.data.currency.currency_symbol) : '\u00A3'; 
                let currObject = (loginResponse.data.currency) ? (loginResponse.data.currency) : {}; 
                let distance_unit = loginResponse.data.distance_unit && loginResponse.data.distance_unit.trim().length > 0 ? loginResponse.data.distance_unit : staticConfigs.DISTANCE_UNIT;
                let img_color = loginResponse.data.profile_color ? loginResponse.data.profile_color : colors[rand];
                let signature = loginResponse.data.signature ? loginResponse.data.signature : '';
                let resObject = { 
                    'refreshToken': loginResponse.data.tokens.refresh, 
                    'accessToken': loginResponse.data.tokens.access, 
                    'user_id': loginResponse.data.user_id,
                    'associate_id':loginResponse.data.associate_id,
                    'username': loginResponse.data.username,
                    'profilename':loginResponse.data.name,
                    'unid':loginResponse.data.unid,
                    'profile_id':loginResponse.data.profile_id,
                    'profile_img':loginResponse.data.image,
                    'user_group':prevState.userGroup,
                    'user_permissions':loginResponse.data.permissions,
                    'profile_currency': currSymbol,
                    'profile_currency_object': currObject,
                    'fcm_notifi_token':'',
                    'fcm_notifi_token_sent':0,
                    'notification_count': loginResponse.data.notification_count,
                    'avatar_name': loginResponse.data.avatar_name,
                    'company_image':loginResponse.data.company_img,
                    'img_color': img_color,
                    'client_default_affiliate_id': 0,
                    'time_zone':loginResponse.data.time_zone,
                    'distance_unit': distance_unit,
                    'login_as_sa_user': 0,
                    'is_active': true,
                    'supervisor_name': loginResponse.data.supervisor_name,
                    'staff_name': loginResponse.data.staff_name,
                    'signature': loginResponse.data.signature,
                    'csv_template_path': loginResponse.data.csv_template_path,
                    'company_name': loginResponse.data.company_name,
                    'omnu_affiliate': loginResponse.data.omnu_affiliate
                };  
                
                if(prevState.userGroup===staticConfigs.LOGIN_SUPER_ADMIN_GROUP){
                    setStorage('super', JSON.stringify(resObject));
                    let unamePwd = getCookie(SUPERADMIN_UNAME_PWD); 
                    if (unamePwd != "") {
                        let arrTmp = unamePwd.split(SEPARATOR); 
                        if(arrTmp.length && arrTmp[0]!='0' && arrTmp[1]!='0') {
                            setCookie(SUPERADMIN_USERNAME, arrTmp[0], EXPIRY_IN_DAYS);
                            setCookie(SUPERADMIN_PASSWORD, arrTmp[1], EXPIRY_IN_DAYS);
                        }
                        else {
                            setCookie(SUPERADMIN_USERNAME, '', EXPIRY_IN_DAYS);
                            setCookie(SUPERADMIN_PASSWORD, '', EXPIRY_IN_DAYS);
                        }
                    }
                    else {
                        setCookie(SUPERADMIN_USERNAME, '', EXPIRY_IN_DAYS);
                        setCookie(SUPERADMIN_PASSWORD, '', EXPIRY_IN_DAYS);
                    }
                }else if(prevState.userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP){
                    setStorage('affiliate', JSON.stringify(resObject));
                    let unamePwd = getCookie(AFFILIATE_UNAME_PWD); 
                    if (unamePwd != "") {
                        let arrTmp = unamePwd.split(SEPARATOR); 
                        if(arrTmp.length && arrTmp[0]!='0' && arrTmp[1]!='0') {
                            setCookie(AFFILIATE_USERNAME, arrTmp[0], EXPIRY_IN_DAYS);
                            setCookie(AFFILIATE_PASSWORD, arrTmp[1], EXPIRY_IN_DAYS);
                        }
                        else {
                            setCookie(AFFILIATE_USERNAME, '', EXPIRY_IN_DAYS);
                            setCookie(AFFILIATE_PASSWORD, '', EXPIRY_IN_DAYS);
                        }
                    }
                    else {
                        setCookie(AFFILIATE_USERNAME, '', EXPIRY_IN_DAYS);
                        setCookie(AFFILIATE_PASSWORD, '', EXPIRY_IN_DAYS);
                    }
                }else if(prevState.userGroup===staticConfigs.LOGIN_CLIENT_GROUP){
                    setStorage('client', JSON.stringify(resObject));
                    let unamePwd = getCookie(CLIENT_UNAME_PWD); 
                    if (unamePwd != "") {
                        let arrTmp = unamePwd.split(SEPARATOR); 
                        if(arrTmp.length && arrTmp[0]!='0' && arrTmp[1]!='0') {
                            setCookie(CLIENT_USERNAME, arrTmp[0], EXPIRY_IN_DAYS);
                            setCookie(CLIENT_PASSWORD, arrTmp[1], EXPIRY_IN_DAYS);
                        }
                        else {
                            setCookie(CLIENT_USERNAME, '', EXPIRY_IN_DAYS);
                            setCookie(CLIENT_PASSWORD, '', EXPIRY_IN_DAYS);
                        }
                    }
                    else {
                        setCookie(CLIENT_USERNAME, '', EXPIRY_IN_DAYS);
                        setCookie(CLIENT_PASSWORD, '', EXPIRY_IN_DAYS);
                    }
                    let dataObj= {
                        clientId: loginResponse.data.profile_id,
                        userGroupToken: loginResponse.data.tokens.access,
                        unid:loginResponse.data.unid        
                    }
                    nextProps.dispatch(loginClientAffiliateListAction(dataObj));
                }
                return {
                    isLoggedIn: true,
                    errorMessage: nextProps.response.login.response.message
                };

            }else if((nextProps.response.login.response) && nextProps.response.login.response.status===400){
                let errMsg = (nextProps.response.login.response.message && MSG_LOGIN_ERRORS[nextProps.response.login.response.message]) ? MSG_LOGIN_ERRORS[nextProps.response.login.response.message] : MSG_LOGIN_ERRORS['common_error'];  
                return {
                    isLoggedIn: false,
                    errorMessage: errMsg
                };
            }
            else if ((!nextProps.response.login.response.hasOwnProperty('affiliates')) && (nextProps.response.login.response) && nextProps.response.login.response.status===400) {
                console.log('nextProps.response.login: ',JSON.stringify(nextProps.response.login)); 
            }
            else{                
                return {
                    isLoggedIn: false,
                    errorMessage: MSG_NETWORK_ERROR
                };
            }
        }
        else if (nextProps.response.login.hasOwnProperty('response') && !nextProps.response.login.response) {
            return {
                isLoggedIn: false,
                errorMessage: MSG_NETWORK_ERROR
            }
        }else{
            return {
                isLoggedIn: false,
                errorMessage: ''
            };
        }
    }

    componentDidUpdate(prevProps) {
        if(parseInt(this.state.callAcceptTerms,10) > 0 && this.state.acceptTermsCalled==0) {
            this.props.dispatch(clearAction()); 
            setStorage('termsUserData', JSON.stringify({...this.state.userData,termsAccepted:true,userGroup:this.state.userGroup}));
            this.setState({callAcceptTerms:0,acceptTermsCalled:1}); 
            if(this.state.userGroup===staticConfigs.LOGIN_SUPER_ADMIN_GROUP){
                this.props.history.push(staticConfigs.ROUTE_TERMS_ACCEPT);
            }else if(this.state.userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP){
            this.props.history.push(staticConfigs.ROUTE_AFFILIATE_TERMS_ACCEPT);
            }else if(this.state.userGroup===staticConfigs.LOGIN_CLIENT_GROUP){
                this.props.history.push(staticConfigs.ROUTE_CLIENT_TERMS_ACCEPT);
            }
        }
    }

    forgotPwd = (userGroup) => {
        if (userGroup===staticConfigs.LOGIN_SUPER_ADMIN_GROUP){
            this.props.history.push(staticConfigs.FORGOT_PASSWORD_ROUTE);
        }else if(userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP){
            this.props.history.push(staticConfigs.FORGOT_PASSWORD_AFFILIATE);
        }else if(userGroup===staticConfigs.LOGIN_CLIENT_GROUP){
            this.props.history.push(staticConfigs.FORGOT_PASSWORD_CLIENT);
        }
    }

    resetForgotPwd = () => {
        this.setState({forgot_username:'', forgot_username_error:'', forgot_password_resp_success:'', 
        forgot_password_resp_error:''}); 
    }

    render() {
        let paramStr = this.props.location.pathname.toLowerCase().trim(); 
        let uGroup = 0; 
        let sPath = staticConfigs.LOGIN_ROUTE_SUPER_ADMIN; 
        let aPath = staticConfigs.LOGIN_ROUTE_AFFILIATE;
        let cPath = staticConfigs.LOGIN_ROUTE_CLIENT; 
        if(paramStr===sPath || paramStr===(sPath+'/')) uGroup = staticConfigs.LOGIN_SUPER_ADMIN_GROUP; 
        else if(paramStr===aPath || paramStr===(aPath+'/')) uGroup = staticConfigs.LOGIN_AFFILIATE_GROUP; 
        else if(paramStr===cPath || paramStr===(cPath+'/')) uGroup = staticConfigs.LOGIN_CLIENT_GROUP; 
        return (
            <React.Fragment>
                <LoginHeader userGroup={uGroup} />
                <LoginView handleChange={this.onHandleChange} handleLogin={this.onHandleLogin} location={this.props.location} {...this.state} uGroup={uGroup} setAffiliate={this.setAffiliate} forgotPwd={this.forgotPwd} resetForgotPwd={this.resetForgotPwd} handleForgotPassword={this.handleForgotPassword} onRememberMe={this.onRememberMe} rememberMe={this.state.rememberMe} />
                <div className="footer-bottom-fixed">
                    <FooterComponent userGroup={uGroup} />
                </div>
            </React.Fragment>            
        )
    }
}

const mapStateToProps = (response) => ({response});
export default connect(mapStateToProps)(withRouter(LoginComponent));